import { api } from "../utils/api";

export const getAulasDisponiveis = async (params) => {
  // console.log('getDisponiveis', params);

  const response = await api.get("/aluno/aulas", { params });

  return response.data;
};
